import {Component, tag} from 'doz'

@tag('socials')
export default class extends Component {

    template(h) {
        return h`
            <style>
                .container {
                    color: ${this.THEME.onSecondaryColor};
                    background: ${this.PLAYER_CONFIG.socialsBackgroundColor || this.THEME.secondaryColor};
                    border-color: ${this.PLAYER_CONFIG.socialsSeparatorColor || ''};
                    text-align: center;
                }
                .icon{
                    color: ${this.PLAYER_CONFIG.socialsIconColor || this.THEME.onSecondaryColor};
                    font-size: 40px;
                    margin: 0 8px;
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.socialsTitleColor || this.THEME.onSecondaryColor};
                }
            </style>
            <div class="container animated fadeIn">
                <h3>${this.PLAYER_CONFIG.socialsTitleText || 'Seguici su'}</h3>
                <div style="display: flex; justify-content: center">
                    <a d-show="${!!this.PLAYER_CONFIG.instagramUrl}" href="${this.PLAYER_CONFIG.instagramUrl}" target="_blank">
                        <i class="icon fab fa-instagram"></i>
                    </a>
                    <a d-show="${!!this.PLAYER_CONFIG.facebookUrl}" href="${this.PLAYER_CONFIG.facebookUrl}" target="_blank">
                        <i class="icon fab fa-facebook"></i>
                    </a>
                    <a d-show="${!!this.PLAYER_CONFIG.twitterUrl}" href="${this.PLAYER_CONFIG.twitterUrl}" target="_blank">
                        <svg width="40" height="40" class="svg-inline--fa fa-x fa-w-16" viewBox="0 0 300 271" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x"
                             role="img" xmlns="http://www.w3.org/2000/svg" data-fa-i2svg="">
                            <path fill="${this.PLAYER_CONFIG.socialsIconColor || this.THEME.onSecondaryColor}"
                                d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/>
                        </svg>
                    </a>
                    <a d-show="${!!this.PLAYER_CONFIG.youTubeUrl}"  href="${this.PLAYER_CONFIG.youTubeUrl}" target="_blank">
                        <i class="icon fab fa-youtube"></i>
                    </a>
                    <a d-show="${!!this.PLAYER_CONFIG.tikTokUrl}"  href="${this.PLAYER_CONFIG.tikTokUrl}" target="_blank">
                        <svg style="width: 42px; height: 42px" class="svg-inline--fa fa-tiktok fa-w-16" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="tiktok"
                             role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-fa-i2svg="">
                            <path fill="${this.PLAYER_CONFIG.socialsIconColor || this.THEME.onSecondaryColor}"
                                  d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"></path>
                        </svg>
                    </a>
                </div>
            </div>
        `
    }


}
